import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Loading from '@/components/Core/Loading'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Validator from '@/utils/Validator'

export default {
  name: 'ServiceAttributeDetail',
  components: {
    Loading
  },
  metaInfo () {
    let title = this.categoryName + '管理 | ' + Constants.SiteInfo.title
    this.setMeta({ title: title })
    return this.getMeta
  },
  props: {
    serviceId: String,
    attributeTypeId: String
  },
  data () {
    return {
      loading: true,
      processing: false,
      registerHash: Constants.RegisterHash,
      
      // テーブルオプション
      tableColumns: [
        'attributeGroupId',
        'attributeGroupName',
        'attributeGroupCode',
        'attributeGroupMailAddress',
        'notifyToDevice',
        'detailButton'
      ],
      tableData: [],
      tableOptions: {
        headings: {
          attributeGroupId: '属性ID',
          attributeGroupName: '属性名',
          attributeGroupCode: '属性コード',
          attributeGroupMailAddress: 'メールアドレス',
          notifyToDevice: '見守り通知端末',
          detailButton: ''
        },
        columnsClasses: {
          attributeGroupId: 'wp-5',
          attributeGroupName: '',
          attributeGroupCode: '',
          attributeGroupMailAddress: '',
          notifyToDevice: '',
          detailButton: 'wp-5 has-button'
        },
        sortable: [
          'attributeGroupId',
          'attributeGroupName',
          'attributeGroupCode',
          'attributeGroupMailAddress'
        ],
        filterable: [],
        texts: Constants.TableOptions.getTexts(this.categoryName),
        // perPage: Constants.TableOptions.perPage.view,
        perPage: Constants.TablePerPageInitial,
        perPageValues: Constants.TableOptions.perPageValues,
        pagination: Constants.TableOptions.pagination
      },

      // 絞込み
      activeFilters: false,
      filterPerPage: Constants.TablePerPageInitial,

      inpMailAddress1: null,
      inpMailAddress2: null,
      inpMailAddress3: null,
      inpMailAddress4: null,
      inpMailAddress5: null,
    }
  },
  // beforeMount () {
  //   if (this.getPermission('Member')) return
  //   this.$router.push({name: 'Home'})
  // },
  mounted () {
    this.$set(this.tableOptions, 'texts', Constants.TableOptions.getTexts(this.categoryName))

    this.init()
  },
  computed: {
    ...mapState({
      categoryName: state => state.serviceAttributeDetail.categoryName,
      attributeGroupModel: state => state.serviceAttributeDetail.attributeGroupModel,
      // form
      values: state => state.serviceAttributeDetail.values,
      // confirm
      confirmKey: state => state.confirm.key,
      confirmAccepted: state => state.confirm.accept,
      // modal
      updatedList: state => state.serviceRegistAttributeGroupModal.updated
    }),
    ...mapGetters({
      getMeta: 'meta/get',
      permittedView: 'permission/permittedView',
      isSmartPhone: 'core/isSmartPhone',
      getValue: 'serviceAttributeDetail/getValue'
    }),

    // list
    deliverySettingList () {
      return Constants.Service.AttributeDeliverySetting.sort(Utility.sortByKey('index', true))
    },
    tablePerPageList () {
      let list = []
      Constants.TablePerPage.forEach(item => list.push({
        value: item,
        label: item
      }))
      return list
    },
    showFilters () {
      return !this.isSmartPhone ||
        this.activeFilters
    },

    // input
    inpAttributeTypeCd: {
      get () {
        return this.values.inpAttributeTypeCd
      },
      set (value) {
        this.setInputValue({
          key: 'inpAttributeTypeCd',
          value: value
        })
      }
    },
    inpDeliverySetting: {
      get () {
        return this.values.inpDeliverySetting
      },
      set (value) {
        this.setInputValue({
          key: 'inpDeliverySetting',
          value: value
        })
      }
    },
    inpNotifyToMailAddresses: {
      get () {
        return this.values.inpNotifyToMailAddresses
      },
      set (value) {
        this.setInputValue({
          key: 'inpNotifyToMailAddresses',
          value: value
        })
      }
    },

    // validate
    inpAttributeTypeCdIsValid () {
      return Validator.validText(this.inpAttributeTypeCd)
    },
    formIsValid () {
      return this.inpAttributeTypeCdIsValid
    },
    disablePostButton () {
      return !this.formIsValid
    }
  },
  watch: {
    confirmAccepted: function (to) {
      console.log('confirmKey : ', this.confirmKey)
      // 登録
      if (this.confirmKey === 'register') {
        if (to) this.postData()
      }
    },
    updatedList: function (to) {
      if (!to) return
      this.init()
    }
  },
  methods: {
    ...mapActions({
      setMeta: 'meta/set',
      showError: 'error/show',
      showConfirm: 'confirm/show',
      showToast: 'toast/show',
      loadModel: 'serviceAttributeDetail/loadModel',
      showServiceRegistAttributeGroupModal: 'serviceRegistAttributeGroupModal/show'
    }),
    ...mapMutations({
      setInputValue: 'serviceAttributeDetail/setInputValue',
    }),

    init () {
      this.loading = true

      //
      let attributeTypeParams = {
        serviceUuid: this.serviceId,
        attributeTypeUuid: this.attributeTypeId
      }

      // データ読出し
      this.loadModel({
        targetId: this.attributeTypeId,
        attributeTypeParams: attributeTypeParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
          this.tableData = $.extend(true, [], this.attributeGroupModel)

          // メールアドレス
          this.inpNotifyToMailAddresses.forEach((item, index) => {
            this['inpMailAddress' + (index + 1)] = item
          })
        })
        .catch(error => {
          this.showError(error || null)
        })
    },

    // ファイル登録
    confirmData() {
      this.showConfirm({
        key: 'register',
        title: '',
        body: 'この' + this.categoryName + '種別設定を変更しますか？'
      })
    },
    postData () {
      this.processing = true

      //
      let parameters = {
        serviceUuid: this.serviceId,
        attributeTypeUuid: this.attributeTypeId,
        request: {
          deliveryTypeCode: this.inpAttributeTypeCd,
          deliveryFlg: this.inpDeliverySetting
        }
      }

      // 通知先メールアドレス
      let emailData = []
      if (this.inpMailAddress1) {
        emailData.push(this.inpMailAddress1)
      }
      if (this.inpMailAddress2) {
        emailData.push(this.inpMailAddress2)
      }
      if (this.inpMailAddress3) {
        emailData.push(this.inpMailAddress3)
      }
      if (this.inpMailAddress4) {
        emailData.push(this.inpMailAddress4)
      }
      if (this.inpMailAddress5) {
        emailData.push(this.inpMailAddress5)
      }
      if (emailData.length) {
        parameters.request.notifyToMailAddresses = emailData
      } else {
        parameters.request.notifyToMailAddresses = []
      }
      console.log('register data', parameters)

      // 登録
      ApiManager.request(
        ['serviceAttributeType'],
        ['v1ServiceAttributeTypePut'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            // toast
            this.showToast({
              title: this.categoryName + '情報の変更',
              body: this.categoryName + 'を変更しました。'
            })

            this.inpMailAddress1 = null;
            this.inpMailAddress2 = null;
            this.inpMailAddress3 = null;
            this.inpMailAddress4 = null;
            this.inpMailAddress5 = null;

            // 一覧データを再読出し
            this.init()

          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    },

    // 登録済み一覧
    getViewData (props) {
      let key = props.column
      let value = props.row[key]

      switch (key) {
        case 'attributeGroupCode':
        case 'attributeGroupMailAddress':
          return value || '未設定'
        case 'notifyToDevice':
          if (value?.hasOwnProperty('deviceSerialNo')) {
            return value.deviceSerialNo
          } else {
            return '未設定'
          }
      }
      return value
    },
    changePage () {
      // console.log(this.$refs.table.page)
    },

    // 絞り込み
    toggleFilters () {
      this.activeFilters = !this.activeFilters
    },
    changePerPage () {
      this.$refs.table.setLimit(this.filterPerPage)
    },

    detailItem (props) {
      this.showServiceRegistAttributeGroupModal({
        serviceUuid: this.serviceId,
        attributeTypeUuid: this.attributeTypeId,
        data: props.row
      })
    }
  }
}